/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendActualSaleDto } from '../../models/backend-actual-sale-dto';
import { BackendPatchedActualSaleRequestDto } from '../../models/backend-patched-actual-sale-request-dto';

export interface MonitoringActualsSalesPartialUpdate$Params {
  id: number;
  body?: BackendPatchedActualSaleRequestDto;
}

export function monitoringActualsSalesPartialUpdate(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringActualsSalesPartialUpdate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendActualSaleDto>> {
  const rb = new RequestBuilder(rootUrl, monitoringActualsSalesPartialUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendActualSaleDto>;
    }),
  );
}

monitoringActualsSalesPartialUpdate.PATH = '/api/monitoring/actuals/sales/{id}/';
